module.exports = __webpack_public_path__ + "static/img/kh-23.706a67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-23.png
// module id = QkGh
// module chunks = 4